module.exports = __webpack_public_path__ + "img/1678419206180-21r-hY8E.67a38c3c.png";